export default class NotificationsUtil {
    static readNotification(id) {
        let notificationsLS = localStorage.getItem('notifications');
        if (notificationsLS) {
            notificationsLS = JSON.parse(notificationsLS);
            notificationsLS = notificationsLS.filter(x => x !== id).concat(id);
            localStorage.setItem('notifications', JSON.stringify(notificationsLS));
        }
    }
}